import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PermissionsEnum } from '../../../api/api-reference';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-remote-command-menu',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterOutlet],
  templateUrl: './remote-command-menu.component.html',
  styleUrl: './remote-command-menu.component.scss',
})
export class RemoteCommandMenuComponent {
  PermissionsEnum=PermissionsEnum;
  constructor(private router: Router, public authService: AuthService) {}

  isActive(tab: string) {
    const currentRoute = this.router.url;
    if (currentRoute.includes(tab)) return true;
    else return false;
  }
  navigate(route: string) {
    this.router.navigate([route]);
  }
}
